export default __webpack_public_path__ + "static/media/cladding34.80e34742.jpeg";